export enum Flow {
  FINANCING_FIRST = '745e80cb-ef17-4014-a4c0-c41fe1df6d77',
  AUTO_FIRST = '599ea7c0-5d12-4ace-b72e-4e359e5ed77e',
  HUBS = 'e8509780-16dc-4918-89f9-f2b9e9ade93d',
  SECOND_HOLDER_AUTO_FIRST = 'f4bf5004-2c54-4544-a64f-40bb0595b284',
  SECOND_HOLDER_FINANCING_FIRST = '2d9be292-3f04-4ec7-8a39-3e93e51162de',
  MY_ACCOUNT = '7e052a66-8171-45ad-8ac4-5448223939cc',
}

export enum FlowNames {
  ffOnline = 'FF Online',
  ffHub = 'FF Hub',
  autoFirst = 'Auto First',
  afBrasil = 'AF Brasil',
  autoFirstBanner = 'Auto First Banner',
  afArgentina = 'AF Arg',
  turnometer = 'TM',
  secondHolder = 'SH',
}
